module.exports = __webpack_public_path__ + "static/media/28T Drive.270a8c66.jpg";